import * as Yup from 'yup';

const PasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
});

export const initialValues: PasswordForm = {
  password: '',
  confirmPassword: ''
};

export default PasswordSchema;
